import { render, staticRenderFns } from "./ProfileDropDownMenu.vue?vue&type=template&id=e2e608dc&scoped=true&"
import script from "./ProfileDropDownMenu.vue?vue&type=script&lang=js&"
export * from "./ProfileDropDownMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDropDownMenu.vue?vue&type=style&index=0&id=e2e608dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e608dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDivider,VList,VListItem,VListItemGroup,VListItemTitle,VMenu})
